import { api } from "@Aspecto/backend/convex/_generated/api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { useRouteContext } from "@tanstack/react-router";

/**
 * Read the current org subdomain from the root route context. On `app.afinio.co`
 * (the entry point) this is null; on `<org>.afinio.co` it is the org slug.
 */
function useSubdomain(): string | null {
  return useRouteContext({ from: "__root__", select: (c) => c.subdomain ?? null });
}

/**
 * The current user's membership row, scoped to the org of the current subdomain.
 * A person can belong to multiple orgs (one row per org); passing the subdomain
 * makes the backend return the row for THIS org (or null if they're not a member).
 * Returns the full react-query result so callers can read `isLoading` etc.
 */
export function useCurrentUser() {
  const subdomain = useSubdomain();
  return useQuery(convexQuery(api.users.getCurrentUser, subdomain ? { subdomain } : {}));
}

/** The current organization, scoped to the current subdomain (see useCurrentUser). */
export function useCurrentCompany() {
  const subdomain = useSubdomain();
  return useQuery(convexQuery(api.companies.getCurrentCompany, subdomain ? { subdomain } : {}));
}
